"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import * as React from "react";
import styled from "styled-components";

import { SVGIcon } from "../SVGIcon";

type Direction = "up" | "down" | "left" | "right" | "upAndRight";

const DirectionalIcon = styled(SVGIcon)<{ direction: Direction }>`
  transform: rotateZ(
    ${({ direction }) => {
      switch (direction) {
        case "right":
          return "0deg";
        case "down":
          return "90deg";
        case "left":
          return "180deg";
        case "upAndRight":
          return "315deg";
        case "up":
        default:
          return "270deg";
      }
    }}
  );
`;

/**
 * @deprecated use Arrow from foundation/Arrow`
 * @trackcomponent
 */
export const Arrow = React.memo(
  ({
    direction,
    className,
    ...props
  }: SVGIcon.IProps & {
    direction: Direction;
  } & React.RefAttributes<SVGElement>) => {
    return (
      <DirectionalIcon
        direction={direction}
        viewBox="0 0 20 16"
        fill="none"
        className={legacyIconCls(className)}
        {...props}
      >
        <path
          d="M19.7071 8.70711C20.0976 8.31658 20.0976 7.68342 19.7071 7.29289L13.3431 0.928932C12.9526 0.538408 12.3195 0.538408 11.9289 0.928932C11.5384 1.31946 11.5384 1.95262 11.9289 2.34315L17.5858 8L11.9289 13.6569C11.5384 14.0474 11.5384 14.6805 11.9289 15.0711C12.3195 15.4616 12.9526 15.4616 13.3431 15.0711L19.7071 8.70711ZM0 9L19 9V7L0 7L0 9Z"
          fill="currentColor"
        />
      </DirectionalIcon>
    );
  }
);

if (process.env.NODE_ENV !== "production") {
  Arrow.displayName = `ArrowIcon`;
}

/**
 * @deprecated use ArrowUp from `@faire/slate/icons/ArrowUp`
 * @trackcomponent
 */
export const ArrowUp = React.memo(
  (props: SVGIcon.IProps & React.RefAttributes<SVGElement>) => {
    return <Arrow direction="up" {...props} />;
  }
);

/**
 * @deprecated use ArrowDown from `@faire/slate/icons/ArrowDown`
 * @trackcomponent
 */
export const ArrowDown = React.memo(
  (props: SVGIcon.IProps & React.RefAttributes<SVGElement>) => {
    return <Arrow direction="down" {...props} />;
  }
);

/**
 * @deprecated use ArrowLeft from `@faire/slate/icons/ArrowLeft`
 * @trackcomponent
 */
export const ArrowLeft = React.memo(
  (props: SVGIcon.IProps & React.RefAttributes<SVGElement>) => {
    return <Arrow direction="left" {...props} />;
  }
);

/**
 * @deprecated use ArrowRight from `@faire/slate/icons/ArrowRight`
 * @trackcomponent
 */
export const ArrowRight = React.memo(
  (props: SVGIcon.IProps & React.RefAttributes<SVGElement>) => {
    return <Arrow direction="right" {...props} />;
  }
);

/**
 * @deprecated use ArrowUpAndRight from `@faire/slate/icons/ArrowUpAndRight`
 * @trackcomponent
 */
export const ArrowUpAndRight = React.memo(
  (props: SVGIcon.IProps & React.RefAttributes<SVGElement>) => {
    return <Arrow direction="upAndRight" {...props} />;
  }
);
